import { NodeRunStatus } from "../domainObjects/nodeRunStatus";

export class RunrefineryRequest {
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    // Identifies which browser TAB is making this run/reset request — the
    // Flask engine checks it against the Edit-lock presence file (the same
    // one server/webApi/DataTransformerAPI/Controllers/ConfigController.cs
    // writes) so a Read-Only tab's run/reset calls are rejected there too,
    // not just hidden client-side. See RefineryPresenceService.tabId.
    tabId: string;
    constructor(userId: string,orgId: string,refineryId: string,nodeId: string,tabId: string = '') {
        this.userId = userId;
        this.orgId = orgId;
        this.refineryId = refineryId;
        this.nodeId = nodeId;
        this.tabId = tabId;
    }
}

export class UpdateNodesStatusRequest {
    refineryConfigID: String = ""
    nodeID: String = ""
    statustoUpdate: NodeRunStatus = NodeRunStatus.PipelineModified

    constructor(refineryConfigID: string, nodeID: string, statustoUpdate: NodeRunStatus ) {
        this.refineryConfigID = refineryConfigID;
        this.nodeID = nodeID;
        this.statustoUpdate = statustoUpdate;
    }
}

export class ResetTransformerRequest {
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    transformId: string;
    constructor(userId: string,orgId: string,refineryId: string,nodeId: string,transformId: string) {
        this.userId = userId;
        this.orgId = orgId;
        this.refineryId = refineryId;
        this.nodeId = nodeId;
        this.transformId = transformId;
    }
}
export class ResetTransformerResponse {
    response_msg: String = ""
    status: String = ""

    constructor(response_msg: String, status: String) {
        this.response_msg = response_msg;
        this.status = status;
    }
}